import { render } from "./AdaugaActivitate.vue?vue&type=template&id=b6210b20"
import script from "./AdaugaActivitate.vue?vue&type=script&lang=js"
export * from "./AdaugaActivitate.vue?vue&type=script&lang=js"

import "./AdaugaActivitate.vue?vue&type=style&index=0&id=b6210b20&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__